import { render } from "./app-footer.vue?vue&type=template&id=26cf1148"
const script = {}

import "./app-footer.vue?vue&type=style&index=0&id=26cf1148&lang=scss"

import exportComponent from "C:\\Users\\Usuario\\Documents\\Git-Repositorios\\edge_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__